var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-container scannedrecord-tag u-inline"},_vm._l((_vm.tags),function(tag){return _c('div',{key:tag.id,staticClass:"tag tag--info"},[_c('strong',[_vm._v(_vm._s(tag.label))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }